import { Link, useParams } from "react-router-dom";

/** What a screen says when its address names nothing it can show. */
export function NotAtThisAddress({ title, back }: { title: string; back: { to: string; label: string } }) {
  return (
    <div className="page">
      <h2 style={{ fontSize: 26, marginBottom: 6 }}>{title}</h2>
      <p className="muted">The link may be old or mistyped. <Link to={back.to}>{back.label}</Link>.</p>
    </div>
  );
}

/**
 * Renders its screen only when every route param named in `checks` passes its format check, and
 * the not-found message otherwise, before any call is made with the value (SEC-20). A param left
 * out of the address (`/vendor` with no job) is not checked.
 */
export function ValidParams({ checks, title, back, children }: {
  checks: Record<string, (value: string) => boolean>;
  title: string;
  back: { to: string; label: string };
  children: React.ReactNode;
}) {
  const params = useParams();
  const bad = Object.entries(checks).some(([name, ok]) => params[name] !== undefined && !ok(params[name] as string));
  return bad ? <NotAtThisAddress title={title} back={back} /> : <>{children}</>;
}
